/*
 * Case Files — real Shopify blog articles.
 *
 * snippets/sat-bootstrap.liquid reads the blog set in Theme settings → Case Files
 * (or the shop's first blog if none is chosen) and reshapes each published article
 * into the exact record shape SATComponent already keeps as this._caseFiles:
 * {no, date, kind, region, tabColor, status, title, body, finding, attachments,
 * clerk, article}. Tag an article "restricted" (or "sealed") and it seals behind the
 * same clearance-code gate an order-linked file uses; tag it "kind:provenance" /
 * "kind:dispatch" / "kind:research" / "kind:field-note" to set its category stamp,
 * and "region:city-name" to set its location line. None of that is required — an
 * untagged post still publishes fine, rotating through the four category stamps.
 *
 * _caseFiles is a plain instance array read directly by several methods elsewhere in
 * sat-app.js — the accordion toggle, the article reader, prev/next, and the
 * #case-file/CF-XXX hash router. Swapping the array itself once, before any of those
 * run, means all of that keeps working completely unchanged; nothing else needed
 * patching. Left untouched (the six shipped demo files stay up) when the chosen blog
 * has no published posts yet, so the section is never empty.
 */
(function () {
  'use strict';
  if (!window.SATComponent) { return; }
  var applied = false;

  function tryApply(self) {
    if (applied) return;
    var files = (window.SAT_DATA && window.SAT_DATA.caseFiles) || [];
    if (!files.length) return;
    applied = true;
    self._caseFiles = files;
  }

  var orig = window.SATComponent.prototype.renderVals;
  window.SATComponent.prototype.renderVals = function () {
    if (!applied) tryApply(this);
    var out = orig.call(this);
    var files = this._caseFiles || [];

    function pad(n) { n = String(n); return n.length < 2 ? '0' + n : n; }

    var openCount = 0, sealedCount = 0, refCount = 0;
    for (var i = 0; i < files.length; i++) {
      if (files[i].status === 'UNDER SEAL') sealedCount++; else openCount++;
      refCount += (files[i].attachments || []).length;
    }
    out.cfOpenCount = pad(openCount);
    out.cfSealedCount = pad(sealedCount);
    out.cfCrossRefCount = pad(refCount);

    // The Case Files page banner (snippets/sat-breadcrumbs.liquid) reads these same
    // three figures from sat-app.js's own hardcoded pageStats map — override just
    // that page's entry so the banner matches the section below it.
    if (this.state && this.state.page === 'casefiles' && Array.isArray(out.pageStats)) {
      out.pageStats = [
        { label: 'FILES OPEN', value: out.cfOpenCount, color: '#C9A227' },
        { label: 'UNDER SEAL', value: out.cfSealedCount, color: '#E08A2E' },
        { label: 'CROSS REFS', value: out.cfCrossRefCount, color: '#8FE39C' }
      ];
    }

    // Reported live: an open case file cuts its own text off mid-sentence on
    // mobile. Root cause is in sat-app.js's own caseFiles mapping — the open/
    // close animation works by CSS-transitioning max-height, and the "open"
    // value is a flat, hardcoded 520px for every file on every screen size,
    // with overflow:hidden clipping anything past it. That's tuned for
    // desktop, where the body text column is wide (grid-template-columns:1fr
    // 210px next to a 24-142px padding gutter) and a several-hundred-character
    // paragraph wraps into relatively few lines. On a narrow phone that same
    // column is much tighter, so the identical text wraps into many more,
    // shorter lines and its real height comfortably exceeds 520px — the
    // overflow then clips it wherever it happens to fall, which is exactly
    // the ragged mid-word cutoff reported ("...which laid t"), not a
    // truncation limit on the text itself (the 320-character cap upstream in
    // sat-bootstrap.liquid is unrelated and already well under what 520px
    // holds on desktop).
    //
    // max-height only caps how tall the box is allowed to grow — a shorter
    // article still sizes to its own content either way — so raising the cap
    // well past anything a real case-file entry (body paragraph + finding
    // note + attachments list) could plausibly need fixes every screen size
    // at once without changing how the animation looks for existing shorter
    // entries.
    if (Array.isArray(out.caseFiles)) {
      out.caseFiles = out.caseFiles.map(function (cf) {
        if (cf && cf.bodyH && cf.bodyH !== '0px') {
          return Object.assign({}, cf, { bodyH: '3000px' });
        }
        return cf;
      });
    }

    return out;
  };
})();
